export default {
  cart_en: r => require.ensure([],
    () => r([require('./en/cart'), require('./en/common'), require('./en/invoice'), require('./en/coupon')]),
    'js/lang-en-cart'),
  cart_zh: r => require.ensure([],
    () => r([require('./zh/cart'), require('./zh/common'), require('./zh/invoice'), require('./zh/coupon')]),
    'js/lang-zh-cart'),
  cart_nl: r => require.ensure([],
    () => r([require('./nl/cart'), require('./nl/common'), require('./nl/invoice'), require('./nl/coupon')]),
    'js/lang-nl-cart'),
  hot_en: r => require.ensure([],
    () => r([require('./en/hot'), require('./en/addcart')]),
    'js/lang-en-hot'),
  hot_zh: r => require.ensure([],
    () => r([require('./zh/hot'), require('./zh/addcart')]),
    'js/lang-zh-hot'),
  hot_nl: r => require.ensure([],
    () => r([require('./nl/hot'), require('./nl/addcart')]),
    'js/lang-nl-hot'),
  home_en: r => require.ensure([],
    () => r([require('./en/home'), require('./en/addcart')]),
    'js/lang-en-home'),
  home_zh: r => require.ensure([],
    () => r([require('./zh/home'), require('./zh/addcart')]),
    'js/lang-zh-home'),
  home_nl: r => require.ensure([],
    () => r([require('./nl/home'), require('./nl/addcart')]),
    'js/lang-nl-home'),
  header_en: r => require.ensure([],
    () => r([require('./en/header')]),
    'js/lang-en-header'),
  header_zh: r => require.ensure([],
    () => r([require('./zh/header')]),
    'js/lang-zh-header'),
  header_nl: r => require.ensure([],
    () => r([require('./nl/header')]),
    'js/lang-nl-header'),
  center_en: r => require.ensure([],
    () => r([require('./en/common'), require('./en/center'), require('./en/coupon'), require('./en/invoice')]),
    'js/lang-en-center'),
  center_zh: r => require.ensure([],
    () => r([require('./zh/common'), require('./zh/center'), require('./zh/coupon'), require('./zh/invoice')]),
    'js/lang-zh-center'),
  center_nl: r => require.ensure([],
    () => r([require('./nl/common'), require('./nl/center'), require('./nl/coupon'), require('./nl/invoice')]),
    'js/lang-nl-center'),
  left_en: r => require.ensure([],
    () => r([require('./en/leftNav')]),
    'js/lang-en-left'),
  left_zh: r => require.ensure([],
    () => r([require('./zh/leftNav')]),
    'js/lang-zh-left'),
  left_nl: r => require.ensure([],
    () => r([require('./nl/leftNav')]),
    'js/lang-nl-left'),
  cookies_en: r => require.ensure([],
    () => r([require('./en/cookies')]),
    'js/lang-en-cookies'),
  cookies_zh: r => require.ensure([],
    () => r([require('./zh/cookies')]),
    'js/lang-zh-shopRes'),
  cookies_nl: r => require.ensure([],
    () => r([require('./nl/cookies')]),
    'js/lang-nl-shopRes'),
  shopRes_en: r => require.ensure([],
    () => r([require('./en/shopRes')]),
    'js/lang-en-shopRes'),
  shopRes_zh: r => require.ensure([],
    () => r([require('./zh/shopRes')]),
    'js/lang-zh-shopRes'),
  shopRes_nl: r => require.ensure([],
    () => r([require('./nl/shopRes')]),
    'js/lang-nl-shopRes'),
  seckill_zh: r => require.ensure([],
    () => r([require('./zh/seckill')]),
    'js/lang-zh-seckill'),
  seckill_en: r => require.ensure([],
    () => r([require('./en/seckill')]),
    'js/lang-en-seckill'),
  seckill_nl: r => require.ensure([],
    () => r([require('./nl/seckill')]),
    'js/lang-nl-seckill')
}



// WEBPACK FOOTER //
// ./resources/js/lib/i18n/loaders.js